import React, { useEffect } from 'react';

interface ColorSelectProps {
	className: string;
	isActive: boolean;
	isLocked: boolean;
	category: string;
	onChange: (name: string, value: boolean) => void;
	isRadio?: boolean;
}

const ColorSelect: React.FC<ColorSelectProps> = ({
	className,
	isActive,
	isLocked,
	category,
	onChange,
	isRadio = true,
}) => {
	const handleChange = () => {
		if (!isLocked) {
			onChange(className, !isActive);
		}
	};

	useEffect(() => {}, [isActive]);

	return (
		<div className="sprite-92-container">
			{isRadio && (
				<input type="radio" name={category} checked={isActive} onChange={handleChange} className="hidden" />
			)}
			{!isRadio && (
				<input type="checkbox" name={category} checked={isActive} onChange={handleChange} className="hidden" />
			)}
			<div className={`cursor-pointer sprite-92 stacked ${className}`} onClick={handleChange}></div>
			{isActive && <div className="cursor-pointer sprite-92 stacked active" onClick={handleChange}></div>}
			{isLocked && <div className="cursor-pointer sprite-92 stacked locked"></div>}
		</div>
	);
};

export default ColorSelect;
